function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_icons_email_1564504",
  transform: "translate(0 -3)"
}, React.createElement("path", {
  id: "email",
  d: "M12.5,3H2.5A2.507,2.507,0,0,0,0,5.5v6.25a2.507,2.507,0,0,0,2.5,2.5h10a2.507,2.507,0,0,0,2.5-2.5V5.5A2.507,2.507,0,0,0,12.5,3Zm1,3.625L8.563,9.938A2.107,2.107,0,0,1,7.5,10.25a2.107,2.107,0,0,1-1.062-.312L1.5,6.625a.661.661,0,0,1-.125-.875.661.661,0,0,1,.875-.125L7.188,8.938a.677.677,0,0,0,.688,0l4.938-3.312a.615.615,0,0,1,.875.188A.682.682,0,0,1,13.5,6.625Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 11.25,
    viewBox: "0 0 15 11.25"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/support.d62f85eb.svg";
export { SvgComponent as ReactComponent };